import {RcnPriceStatsResponse} from "../types/RcnPriceStatsResponse";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";

export const getPublishableRcnPoint = (response: RcnPriceStatsResponse | null | undefined): RcnPriceStatsSeriesPoint | null => {
    const point = response?.series[0];

    return point && point.value > 0 ? point : null;
};
import {RcnPriceStatsResponse} from "../types/RcnPriceStatsResponse";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";

export const getPublishableRcnPoint = (response: RcnPriceStatsResponse | null | undefined): RcnPriceStatsSeriesPoint | null => {
    const point = response?.series[0];

    return point && point.value > 0 ? point : null;
};
